import React from 'react';
import { Pagination, Tag, Button, Divider, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { ROUTER } from '../../../constants/router';
import usePermission from '../../../hooks/usePermission';

export default function ListCard({
    setLoading,
    currentPage,
    onChangePage,
    setOpenDelete,
    dataSource,
    setBusinessProcess,
}) {
    const { t, i18n } = useTranslation();

    const _getTagStatus = (e) => {
        if (e === 'Draft') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {t('dataFlow.Draft')}
                </Tag>
            );
        } else if (e === 'Waiting for Review') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {t('dataFlow.Waiting for Review')}
                </Tag>
            );
        } else if (e === 'Reviewed') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {t('dataFlow.Reviewed')}
                </Tag>
            );
        } else if (e === 'Revise') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {t('dataFlow.Revise')}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const { isAuditor } = usePermission();

    return (
        <>
            <div className="overflow-auto max-h-[58vh] mt-2">
                <div className="mr-1 px-4">
                    {dataSource?.length > 0 ? (
                        dataSource.map((e, i) => {
                            return (
                                <div
                                    key={i}
                                    className="bg-white rounded-md shadow-sm p-[22px] px-[18px] mt-3 transform duration-300 hover:scale-[1.01] border-hover"
                                >
                                    {e?.isRequestRevise === '1' && (
                                        <div className="bg-[#FFECF0] text-[#F0536F] rounded-md font-semibold px-3 w-max mb-2">
                                            <svg
                                                width="8"
                                                height="8"
                                                viewBox="0 0 8 8"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <circle
                                                    cx="4"
                                                    cy="4"
                                                    r="4"
                                                    fill="#F0536F"
                                                />
                                            </svg>{' '}
                                            {t(
                                                'There is a request for revise from waiting for approval',
                                                { name: e?.updateBy }
                                            )}
                                        </div>
                                    )}
                                    <div className="flex items-center justify-between mb-2">
                                        <Link
                                            to={`${ROUTER.DS_INVENTORY.DATAFLOW}/${e?.businessProcessId}/view`}
                                        >
                                            <Descriptions className="pr-4">
                                                <Descriptions.Item
                                                    className="!pb-0"
                                                    label={
                                                        <span className="text-base font-medium text-purple">
                                                            {e?.businessProcessName ||
                                                                '-'}
                                                        </span>
                                                    }
                                                >
                                                    <span className="text-base font-medium text-purple">
                                                        {e?.businessProcessFullName ||
                                                            '-'}
                                                    </span>
                                                </Descriptions.Item>
                                            </Descriptions>
                                        </Link>
                                        {(e.statusEn === 'Draft' ||
                                            e.statusEn === 'Revise') && (
                                            <Button
                                                disabled={isAuditor}
                                                onClick={() => {
                                                    setOpenDelete(true);
                                                    setBusinessProcess({
                                                        businessProcessId:
                                                            e.businessProcessId,
                                                        businessProcessName:
                                                            e.businessProcessName,
                                                    });
                                                }}
                                                className="disabled:opacity-50 view-bn flex-shrink-0 flex items-center px-2.5"
                                            >
                                                <svg
                                                    width="15"
                                                    height="15"
                                                    viewBox="0 0 14 14"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M6.9998 2.18332e-08C7.54871 -7.72662e-05 8.07782 0.205044 8.48324 0.575088C8.88866 0.945132 9.1411 1.45337 9.191 2H12.5998C12.7518 2.00005 12.8982 2.0578 13.0092 2.16158C13.1203 2.26536 13.1879 2.40744 13.1982 2.5591C13.2086 2.71077 13.161 2.86071 13.0651 2.97864C12.9691 3.09656 12.832 3.17368 12.6814 3.1944L12.5998 3.2H12.1334L11.1198 11.984C11.0747 12.3739 10.8878 12.7336 10.5947 12.9947C10.3016 13.2558 9.92273 13.4001 9.5302 13.4H4.4694C4.07688 13.4001 3.69804 13.2558 3.40494 12.9947C3.11184 12.7336 2.92494 12.3739 2.8798 11.984L1.8654 3.2H1.3998C1.25481 3.19999 1.11473 3.14749 1.00546 3.05219C0.896189 2.95689 0.825123 2.82524 0.805405 2.6816L0.799805 2.6C0.799811 2.45501 0.852319 2.31493 0.947618 2.20566C1.04292 2.09638 1.17456 2.02532 1.3182 2.0056L1.3998 2H4.8086C4.85851 1.45337 5.11095 0.945132 5.51637 0.575088C5.92179 0.205044 6.4509 -7.72662e-05 6.9998 2.18332e-08ZM5.7998 5C5.6038 5 5.4398 5.124 5.4062 5.2872L5.3998 5.3504V10.2504L5.4062 10.3128C5.4398 10.476 5.6038 10.6 5.7998 10.6C5.9958 10.6 6.1598 10.476 6.1934 10.3128L6.1998 10.2496V5.3512L6.1934 5.2872C6.1598 5.1248 5.9958 5 5.7998 5ZM8.1998 5C8.0038 5 7.8398 5.124 7.8062 5.2872L7.7998 5.3504V10.2504L7.8062 10.3128C7.8398 10.476 8.0038 10.6 8.1998 10.6C8.3958 10.6 8.5598 10.476 8.5934 10.3128L8.5998 10.2496V5.3512L8.5934 5.2872C8.5598 5.1248 8.3958 5 8.1998 5ZM6.9998 1.2C6.5158 1.2 6.1118 1.544 6.0198 2H7.9798C7.887 1.544 7.4838 1.2 6.9998 1.2Z"
                                                        fill="#7B67FB"
                                                    />
                                                </svg>
                                            </Button>
                                        )}
                                    </div>
                                    <Divider className="mb-2 mt-4" />
                                    <div className="grid grid-cols-2 gap-4">
                                        <div className="space-y-2">
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('dataFlow.Department')}:
                                                </div>
                                                <div className="break-all">
                                                    {i18n.language === 'en'
                                                        ? e.departmentNameEn
                                                        : e.departmentNameTh
                                                        ? e.departmentNameTh
                                                        : '-'}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('Status')} :
                                                </div>
                                                <div className="break-all">
                                                    {_getTagStatus(e.statusEn)}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('dataFlow.Purpose')} :
                                                </div>
                                                <div className="break-all">
                                                    {e.purposeName || '-'}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('dataFlow.CreateDate')} :
                                                </div>
                                                <div className="break-all">
                                                    {e.createDate || '-'}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('dataFlow.UpdateDate')} :
                                                </div>
                                                <div className="break-all">
                                                    {e.modifyDate || '-'}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t('dataFlow.ReviewBy')} :
                                                </div>
                                                <div>
                                                    <div className="break-all">
                                                        {e.reviewBy || '-'}
                                                    </div>
                                                    {e.reviewBy2 && (
                                                        <div className="break-all">
                                                            {e.reviewBy2 || '-'}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="grid grid-cols-2">
                                                <div className="font-semibold">
                                                    {t(
                                                        'dataFlow.LastReviewDate'
                                                    )}{' '}
                                                    :
                                                </div>
                                                <div className="break-all">
                                                    {e.reviewDate || '-'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="h-[60vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    pageSizeOptions={[10, 25, 50]}
                    defaultPageSize={10}
                    total={currentPage?.total || 1}
                    current={currentPage?.page || 1}
                    showSizeChanger
                    onChange={(page, pageSize) => {
                        setLoading(true);
                        onChangePage({
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        });
                    }}
                />
            </div>
        </>
    );
}
